const divider = {
  baseStyle: {
    position: "relative",
    borderColor: "primary.800",
    opacity: "1",
    borderBottomWidth: "0",
    _before: {
      content: "' '",
      position: "absolute",
      top: "0",
      left: "5%",
      right: "5%",
      width: "90%",
      height: "3px",
      backgroundImage:
        "linear-gradient(to right, transparent 2.5%, #233B5E 50%, transparent 97.5%)",
    },
  },
  variants: {
    arrow: {
      _after: {
        content: "' '",
        position: "absolute",
        zIndex: "1",
        top: "-5px",
        left: "calc(50% - 7px)",
        width: "13px",
        height: "13px",
        transform: "rotate(45deg)",
        backgroundColor: "#111C2C",
        borderBottom: "2px solid #233B5E",
        borderRight: "2px solid #233B5E",
      },
    },
  },
}

export default divider
